import classNames from "classnames"

export default class NewOrderSlotsListing extends React.PureComponent {
  state = {
    offset: 0,
    limit: 10,
  }

  componentDidMount() {
    this.handleInitialSlotsLoad();
  }

  handleInitialSlotsLoad() {
    if (this.props.slots.length == 0) {
      const startDate = moment().format(moment.RUBY_DATE_FORMAT);
      const endDate = moment().add(3, "months").endOf("month").format(moment.RUBY_DATE_FORMAT);

      this.props.onInitialSlotsLoad(startDate, endDate);
    }
  }

  render() {
    const { selectedSlot, onSlotSelect, product } = this.props
    const slots = this.props.slots
    const { offset, limit } = this.state
    const getPvForSlot = slot => (
      product.product_variants.find(pv => pv.id == slot.product_variant_id)
    )
    const getLabelForSlot = slot => (
      slot.display_as_confirmed ? I18n.t("papp.components.SlotsCalendar.slot_confirmed") : ''
    )
    return (
      <div className="NewOrderSlotsListing">
        {slots.slice(offset, offset + limit).map(slot => (
          <div
            key={slot.id}
            className={classNames("NewOrderSlotsListing-slot", {
              "is-disabled": !slot.stock_available,
              "is-busy": !slot.stock_available,
              "is-available": slot.stock_available,
              "is-confirmed": slot.stock_available && slot.display_as_confirmed,
              "is-selected": (selectedSlot && slot.id === selectedSlot.id),
            })}
            onClick={() => onSlotSelect(slot)}
            >
            <div className="NewOrderSlotsListing-slot-content">
              <div className="NewOrderSlotsListing-slot-date">
                {st.formatTimeRange(slot.starts_at, slot.ends_at, { includeTime: slot.includes_time })}
              </div>
              <div className="NewOrderSlotsListing-slot-product">
                {getPvForSlot(slot).name}
              </div>
            </div>
            <div className="NewOrderSlotsListing-slot-label">
              {getLabelForSlot(slot)}
            </div>
          </div>
        ))}

        {slots.length > limit && (
          <div className="NewOrderSlotsListing-pagination">
            <a
              className="btn btn-default u-forceInlineBlockDisplay"
              hidden={offset <= 0}
              onClick={() => this.setState({ offset: offset - limit })}>
              &laquo; {I18n.t("fe.NewOrderCalendarForm.previous_slots")}
            </a>
            &nbsp;
            <a
              className="btn btn-default u-forceInlineBlockDisplay"
              hidden={slots.length <= offset + limit}
              onClick={() => this.setState({ offset: offset + limit })}>
              {I18n.t("fe.NewOrderCalendarForm.next_slots")} &raquo;
            </a>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/NewOrderSlotsListing.jsx